<template>
  <div
    v-if="geo"
    class="player-label"
  >
    <div
      class="geo"
      @click="clickPlayerLabel('geo')"
    >
      <i />
      <div class="p">
        {{ geo }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ModelMetaFeed } from '@/types/model';

const enum EEmitEvent {
  onClickLabel = 'on-click-label',
}

export default defineComponent({
  components: {},
  props: {
    feed: {
      type: Object as PropType<ModelMetaFeed>,
      default: () => ({}),
    },
    animate: {
      type: Boolean,
      default: true,
    },
  },
  emits: [EEmitEvent.onClickLabel],
  computed: {
    geo() {
      const { geoInfo } = this.feed;
      if (!geoInfo || !geoInfo.city || !geoInfo.name) return '';
      return `${geoInfo.city}·${geoInfo.name}`;
    },
  },
  methods: {
    clickPlayerLabel(tag: string) {
      this.$emit(EEmitEvent.onClickLabel, tag);
    },
  },
});
</script>

<style lang="scss" scoped>
.player-label,
.music,
.geo {
  display: flex;
  align-items: center;
}
.player-label {
  @include responsiveStyleSingle(margin-top, 3.6,'vw');
  @include responsiveStyleSingle(margin-bottom, 3.2,'vw');
}
.music,
.geo {
  i {
    @include responsiveStyleSingle(height, 4.2667, 'vw');
    @include responsiveStyleSingle(width, 4.2667, 'vw');
    background-size: 100% 100%;
    @include responsiveStyleSingle(margin-right, 0.5333, 'vw');
  }
  .p {
    @include responsiveStyleSingle(line-height, 4.2667, 'vw');
    @include responsiveStyleSingle(font-size, 3.2, 'vw');
  }
}

.music {
  @include responsiveStyleSingle(margin-right, 2.6667, 'vw');
  .p {
    @include responsiveStyleSingle(max-width, 40, 'vw');
  }
  i {
    background-image: url('https://isee.weishi.qq.com/daguo/img/music.png');
  }
}
.geo {
  flex: 1;
  overflow: hidden;
  i {
    background-image: url(https://isee.weishi.qq.com/daguo/img/geo.png);
  }
  .p {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
